import React from 'react';
import PropTypes from 'prop-types';
import DateTime from 'react-datetime';
import { StatePicker } from '@td/practice_management_js';

const ProviderSurgeIncentiveCreateForm = ({
  formValues,
  changeField,
  submit,
  formErrors,
  submitting
}) => (
  <div id="new-incentive">
    <div className="content-container">
      {formErrors.map(error => (
        <div key={error} className="surge-error">
          {error}
        </div>
      ))}
      <div className="filter">
        <label htmlFor="start-date">Start Date/Time:</label>
        <DateTime
          value={formValues['start-date']}
          onChange={value => changeField({ target: { name: 'start-date', value } })}
          locale="en-US"
          closeOnSelect
          inputProps={{
            name: 'start-date',
            id: 'start-date'
          }}
        />
      </div>
      <div className="filter">
        <label htmlFor="end-date">End Date/Time:</label>
        <DateTime
          value={formValues['end-date']}
          onChange={value => changeField({ target: { name: 'end-date', value } })}
          locale="en-US"
          closeOnSelect
          inputProps={{
            name: 'end-date',
            id: 'end-date'
          }}
        />
      </div>
      <div className="filter">
        <label htmlFor="amount">Amount</label>
        <input
          value={formValues.amount}
          onChange={changeField}
          id="amount"
          name="amount"
          type="number"
          min="1"
        />
      </div>
      <div className="filter">
        <label htmlFor="states">Location</label>
        <StatePicker
          id="states"
          name="states"
          onSelect={(_, value) => changeField({ target: { name: 'states', value } })}
          multiple
        />
      </div>
      <div disabled={submitting} className="button" onClick={submit}>
        {submitting ? 'Saving...' : 'Create'}
      </div>
    </div>
  </div>
);

ProviderSurgeIncentiveCreateForm.propTypes = {
  formValues: PropTypes.object.isRequired,
  formErrors: PropTypes.array.isRequired,
  changeField: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired
};

export default ProviderSurgeIncentiveCreateForm;
